import React, { PropTypes, Component } from 'react'
import unescape from 'unescape';
import style from './style.css';

class Body extends Component {
    render() {
        const { page, content } = this.props
        return (
            <div>
            {page && <div className={ style.pageBody } dangerouslySetInnerHTML={ { __html: unescape(page.body) } } /> }
            {content && <div className={ style.pageBody } dangerouslySetInnerHTML={ { __html: unescape(content) } } /> }
            </div>
        )
    }
}

export default Body



// WEBPACK FOOTER //
// ./src/components/pagescreen/body/index.js